/* src/pages/companies/page-companies.component.scss */
:host {
  display: block;
}
.tender-manager-col--actions {
  width: 120px;
}
.tender-manager-col--company-type {
  width: 10rem;
}
/*# sourceMappingURL=page-companies.component-QO5PDPD4.css.map */
